import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GraficoProcessosService {

  graficoProcessos$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  getGrafico() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/Graficos/" + environment.empresa

      this.http.get(url).subscribe({
        next: (data) => this.graficoProcessos$.next(data),
        error: (error: HttpErrorResponse) => {
          this.graficoProcessos$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }  
      }).add(() => {
        this.graficoProcessos$.unsubscribe(),
        this.graficoProcessos$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}
